export enum UserLocalStorageKey {
  // base URL
  BaseURL = "base_url",

  // simple loading state
  InsulinsLoadedBefore = "insulins_loaded_before",
  AccountInsulinsLoadedBefore = "account_insulins_loaded_before",
  MedicationsLoadedBefore = "medications_loaded_before",
  AccountMedicationsLoadedBefore = "account_medications_loaded_before",
  EntryTemplatesLoadedBefore = "entry_templates_loaded_before",

  // aggregated paginated loading states
  EventsLoadedRanges = "events_loaded_ranges",
  EntriesLoadedRanges = "entries_loaded_ranges",

  // database last trimmed dates
  EntriesLastTrimmedAt = "entries_last_trimmed_at", // TODO
  EventsLastTrimmedAt = "events_last_trimmed_at", // TODO
}

export enum GlobalLocalStorageKey {
  CountryCodeSelection = "country_code_selection",
  TrackingTechnologyConsentResponse = "tracking_technology_consent_response",
}

export type LocalStorageKey = (UserLocalStorageKey | GlobalLocalStorageKey) & string
